// LLM-generated prose (digest / module adoption summaries / analysis text)
// frequently embeds ISO dates like "2026-04-05". The canonical CSP surface
// format is dd-mmm-yy (see format_date_dd_mmm_yy). This render-time transform
// rewrites bare ISO dates in free text to dd-mmm-yy so summaries read the same
// way as every other date on the page — deterministically, without waiting for
// the model to regenerate. Parses Y/M/D directly (no Date()) to avoid timezone
// drift on date-only strings.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const ISO_DATE = /\b(\d{4})-(\d{2})-(\d{2})\b/g;

const reformat_prose_dates = (text) => {
    if (!text || typeof text !== 'string') return text;
    return text.replace(ISO_DATE, (m, y, mo, d) => {
        const mi = parseInt(mo, 10) - 1;
        const dd = parseInt(d, 10);
        if (mi < 0 || mi > 11 || dd < 1 || dd > 31) return m; // not a real date — leave as-is
        return `${d}-${MONTHS[mi]}-${y.slice(-2)}`;
    });
};

export default reformat_prose_dates;
